import { useEffect } from 'react';

import { scrollToTop } from '../scrollToTop';

export const useScrollToTopOnDependencyChange = (dependency: unknown, behavior: ScrollBehavior = 'auto') => {
  useEffect(() => {
    scrollToTop(behavior);
  }, [behavior, dependency]);
};
